export const isProd = import.meta.env.VITE_APP_ENV === "prod";

export const SEERI_SUPPLIER_ID = isProd
  ? "92a89ffd-5c10-4a6c-a532-f45a31803625"
  : undefined;
